module.exports = __webpack_public_path__ + "img/border-heading-wit.5197765.svg";